//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as mailGroupAction from '../action/mailGroupAction';
import * as notificationAction from '../action/notificationAction';
import * as partnerOperationAction from '../action/partnerOperationAction';
import * as helpAction from '../action/helpAction';
import * as uiAction from '../action/uiAction';
//Material-ui
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Select from '@material-ui/core/Select';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
//func
import atom2datetime from '../func/atom2datetime';
//Menu
import MenuMailbox from './MenuMailbox';
//Part
import PartUserMainImg from './PartUserMainImg';
import PartUserName from './PartUserName';
import PartPagingNextPrev from './PartPagingNextPrev';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import RefreshIcon from '@material-ui/icons/Refresh';
import SendIcon from '@material-ui/icons/Send';
import MoreVertSharpIcon from '@material-ui/icons/MoreVertSharp';

class Comp extends React.Component {

  constructor(props) {
    super(props);
  	this.state = {
      mailGroupEditAnchor: null,
      mailGroupEditPic: null,
      mailGroupEditName: null,
      mailGroupDelPic: null,
  	}
  }

  componentDidMount() {
    document.title = 'メールボックス - パートナーズ';
    if (this.props.history.action === 'PUSH' || !this.props.mailGroup.datetime) {
      this.props.mailGroupListGet(this.props.mailGroup.filter, 1);
      window.scrollTo(0, 0);
    }
  }

  _filterChange(value) {
    this.props.mailGroupListGet(value, 1);
  }

  _onPaging(page) {
    this.props.mailGroupListGet(this.props.mailGroup.filter, page);
    window.scrollTo(0, 0);
  }

	_renderList(item, index, arr) {
		return (
      <div
        key={index}
        style={{
          padding:'5px',
          borderBottom: (arr.length - 1 > index) ? 'solid 1px #DDD': '',
          backgroundColor: (item.mail_unconfirmed_cnt > 0) ? '#FFE7C2': '#FFF'
        }}
      >
        {
          (item.mail_type === 0) ? (
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
              }}
            >
              <div
                onClick={ () => this.props.history.push({pathname: '/mailbox/talk/' + item.pic, referrer: '/mailbox/talk/'}) }
                style={{padding:'5px',cursor:'pointer'}}
              >
                <PartUserMainImg
                  mainImg={item.userdata_mainImg}
                  width={60}
                  height={60}
                  radius={'50%'}
                />
              </div>
              <div
                onClick={ () => this.props.history.push({pathname: '/mailbox/talk/' + item.pic, referrer: '/mailbox/talk/'}) }
                style={{padding:'5px',cursor:'pointer'}}
              >
                <div
                  style={{padding:'5px'}}
                >
                  <div>
                    <PartUserName
                      data={{
                        name: item.userdata_name,
                        sex: item.userdata_sex,
                        size: '1.2em',
                      }}
                    />&nbsp;
                    <span style={{color:'#333'}}>{item.userdata_age}才 {item.userdata_region}</span>
                  </div>

                  <div>{item.mail_cnt}件</div>
                  <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                    <div style={{width:'30px'}}>
                      {
                        (item.mail_send_or_receive === 'send') ? (
                          (this.props.my.profile.userdata_sex === 'men') ? (
                            <SendIcon style={{transform:'rotate(-45deg)', color:'#A6BDD5', verticalAlign:'middle'}} />
                          ): (
                            <SendIcon style={{transform:'rotate(-45deg)', color:'#E7B0D0', verticalAlign:'middle'}} />
                          )
                        ) : (
                          (this.props.my.profile.userdata_opposite_sex === 'men') ? (
                            <SendIcon style={{transform:'rotate(135deg)', color:'#A6BDD5', verticalAlign:'middle'}} />
                          ): (
                            <SendIcon style={{transform:'rotate(135deg)', color:'#E7B0D0', verticalAlign:'middle'}} />
                          )
                        )
                      }
                    </div>

                    <div style={{color:'#333'}}>
                      {atom2datetime(item.mail_transmission_atom, 'DT')}
                    </div>
                  </div>

                </div>
                {
                  (item.not_match_important === 1) && (
                    <Button
                      size='small'
                      variant="outlined"
                      color="primary"
                      onClick={ (event) => {
                        event.stopPropagation();
                        this.props.popoverOpen(event.currentTarget, 'お相手が希望条件の重要項目と異なる為、メールフィルターで既読になりました');
                      }}
                    >
                      メールフィルター
                    </Button>
                  )
                }
              </div>

              <div style={{marginLeft: 'auto'}}>
                <IconButton
                  onClick={ (event) => this.setState({mailGroupEditPic:item.pic,　mailGroupEditName:item.userdata_name, mailGroupEditAnchor:event.currentTarget}) }
                >
                  <MoreVertSharpIcon />
                </IconButton>
              </div>

      			</div>
          ) : (
            <div
              style={{
                display:'flex',
                flexDirection:'row',
                alignItems:'center',
              }}
            >
              <div
                onClick={ () => this.props.history.push({pathname: '/mailbox/support/', referrer: '/mailbox/talk/'}) }
                style={{padding:'5px',cursor:'pointer'}}
              >
                <PartUserMainImg
                  mainImg={{
                    src: null,
                    sex: this.props.my.profile.userdata_opposite_sex,
                  }}
                  width={'60px'}
                  height={'60px'}
                  radius={'50%'}
                />
              </div>
              <div
                onClick={ () => this.props.history.push({pathname: '/mailbox/support/', referrer: '/mailbox/talk/'}) }
                style={{padding:'5px',cursor:'pointer'}}
              >

                <PartUserName
                  data={{
                    name: 'カスタマーサポート',
                    sex: this.props.my.profile.userdata_opposite_sex,
                    size: '1.2em',
                  }}
                />
                <div>{item.mail_cnt}件</div>
                <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                  <div style={{width:'30px'}}>
                  {
                    (this.props.my.profile.userdata_opposite_sex === 'men') ? (
                      <SendIcon style={{transform:'rotate(135deg)', color:'#A6BDD5', verticalAlign:'middle'}} />
                    ): (
                      <SendIcon style={{transform:'rotate(135deg)', color:'#E7B0D0', verticalAlign:'middle'}} />
                    )
                  }
                  </div>

                  <div style={{color:'#333'}}>
                    {atom2datetime(item.mail_transmission_atom, 'DT')}
                  </div>
                </div>

              </div>
      			</div>
          )
        }

      </div>
		);
	};



	_imgOpenModal  = () => {
		this.setState({imgModalVisible: true});
	}

	render() {

		return (
      <div>
        <div style={{maxWidth:'480px', margin:'auto'}}>
          <MenuMailbox />
        </div>
        <div style={{maxWidth:'600px', margin:'auto'}}>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
              margin: '10px',
            }}
          >
            <div>
              <Select
                value={this.props.mailGroup.filter}
                onChange={ (e) => this._filterChange(e.target.value) }
              >
                <MenuItem value={ 'all' }>すべて</MenuItem>
                <MenuItem value={ 'unconfirmed' }>未読</MenuItem>
                <MenuItem value={ 'favorite' }>お気に入り会員</MenuItem>
              </Select>

            </div>
            <div>
              <span style={{color:'#666'}}>ページ{this.props.mailGroup.page}</span>

              <IconButton
                onClick={ () => this.props.mailGroupListGet(this.props.mailGroup.filter, 1) }
              >
                <RefreshIcon />
              </IconButton>
            </div>
          </div>
          {
            (this.props.mailGroup.datetime) && (
              (this.props.mailGroup.list.length > 0) ? (
                <div>

                  <Box boxShadow={2} style={{background:'#FFF'}}>
                    {
                      this.props.mailGroup.list.map(
                      	(value, index, arr) => this._renderList(value, index, arr)
                    	)
            				}
                  </Box>

                  <div style={{margin:'15px'}}>
                    <PartPagingNextPrev
                      page={this.props.mailGroup.page}
                      isNext={this.props.mailGroup.isListNext}
                      onClick={ (e) => this._onPaging(e) }
                    />
                  </div>

                  <div align='center' style={{margin:'15px'}}>
                    <Button
                      color='primary'
                      variant={ "outlined" }
                      onClick={ () => this.props.helpOpen('id', '430,373,475,376,451,476,458,41') }
                    >
                      メールでよくある質問
                    </Button>
                  </div>

                </div>
              ) : (
                <h2 align='center' style={{padding:'30px 0px'}}>
                  <span className='i-b'>メールが見つかりませんでした</span>
                </h2>
              )
            )
          }
      	</div>
        <Menu
          anchorEl={this.state.mailGroupEditAnchor}
          keepMounted
          open={(this.state.mailGroupEditPic)? true: false}
          onClick={ () => this.setState({mailGroupEditPic: null}) }
        >
          <MenuItem
            onClick={ () => this.props.history.push({pathname: '/partner/' + this.state.mailGroupEditPic, referrer: '/mailbox/'}) }
          >
            <div>
              {this.state.mailGroupEditName} さんのプロフィールを見る
            </div>
          </MenuItem>
          <MenuItem
            onClick={ () => {
              this.setState({mailGroupDelPic:this.state.mailGroupEditPic});
            }}
          >
            <div>
               {this.state.mailGroupEditName} さんとのメールを全て削除する
            </div>
          </MenuItem>
          <MenuItem
            onClick={ () => this.props.partnerOperationOpen(this.state.mailGroupEditPic, ['refusal']) }
          >
            <div>
               {this.state.mailGroupEditName} さんからのメールをブロックする
            </div>
          </MenuItem>
        </Menu>

        <DialogConfirm
          open={ (this.state.mailGroupDelPic) ? true : false }
          title={'メールの削除'}
          content={(
            <div>
              <div>
                {this.state.mailGroupEditName}さんとのメールをすべて削除しますか？
              </div>
              <div style={{fontSize:'0.9em',color:'#666'}}>
                ※削除したメールは復元できません。<br/>
                ※メールは相手側のメールボックスからは削除されません。<br/>
                ※写真・ボイスメールは相手側のメールボックスからも削除されます。
              </div>
            </div>
          )}
          apply={ () => {
            this.props.mailGroupItemDel(this.state.mailGroupDelPic);
            this.setState({mailGroupDelPic: null});
          }}
          close={ () => this.setState({mailGroupDelPic: null}) }
        />
      </div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		ui: state.ui,
    my: state.my,
		mailGroup: state.mailGroup,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
		...mailGroupAction,
    ...notificationAction,
    ...partnerOperationAction,
    ...helpAction,
    ...uiAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
